<!--
 * @Description: 仪表盘页面
 * @Date: 2020-01-06 09:19:28
 * @LastEditTime: 2021-06-22 14:06:07
 -->

<template>
  <el-container id="Dashboard">
    <!-- S 主体内容 -->
    <el-container v-loading="data.loading" class="wrapper">
      <div class="side-wrap" :style="`width: ${screenFit.slideWidth}%;`">
        <div class="side-content" :style="`min-height:${minHeight}px`">
          <div class="role">
            <img
              v-if="accountType == 3"
              src="~assets/imgs/dashboard/icon_biaoqian2.png"
              alt="avatar"
            >
            <!-- /试用版 -->
            <img v-if="accountType == 4" src="~assets/imgs/dashboard/icon_bianqian.png" alt="avatar">
            <!-- /体验版 -->
          </div>

          <section id="Company">
            <!-- S 公司名称/logo -->
            <div class="company-header">
              <div class="content" :style="`padding-top:${screenFit.logoPadding}px;padding-bottom:${screenFit.logoPadding}px;`">
                <div class="logo">
                  <img v-if="companyInfo.logo" :src="companyInfo.logo">
                  <img v-else src="~assets/imgs/dashboard/icon_gongsi.png" alt="default logo">
                </div>
                <h6>{{ companyInfo.companyName }}</h6>
                <p v-if="accountType == 3 || (accountType == 4 && !isMainAccount)">
                  『试用剩余：{{ companyInfo.expDays || 0 }}天』
                </p>
              </div>
            </div>
            <!-- E 公司名称/logo -->

            <!-- S 账户信息 -->
            <div class="company-footer">
              <div class="content" :style="`padding-top:${screenFit.logoPadding}px;padding-bottom:${screenFit.logoPadding}px;`">
                <ul>
                  <li>
                    <div class="label">
                      <img class="icon" src="~assets/imgs/dashboard/icon_zgabfhu.png" alt>
                      <span class="text">账户类型：</span>
                    </div>
                    <span>{{ isMainAccount ? '主' : '子' }}账户</span>
                  </li>
                  <li>
                    <div class="label">
                      <img class="icon" src="~assets/imgs/dashboard/icon_cunchu.png" alt>
                      <span class="text">存储空间：</span>
                    </div>
                    <span>不限（已使用：{{ data.diskUsage }}）</span>
                  </li>
                  <li>
                    <div class="label">
                      <img class="icon" src="~assets/imgs/dashboard/icon_shendu.png" alt>
                      <span class="text">深度取证：</span>
                    </div>
                    <span v-if="(accountType ==4) && isMainAccount">不限（已使用：{{ companyInfo.orgDepthForensicNumber || 0 }}次）</span>
                    <span v-else-if="(accountType ==4) && !isMainAccount">{{ companyInfo.userDepthForensicAmount || 0 }}次（已使用：{{ companyInfo.userDepthForensicNumber || 0 }}次）</span>
                    <span v-else>{{ companyInfo.orgDepthForensicAmount || 0 }}次（已使用：{{ companyInfo.orgDepthForensicNumber || 0 }}次）</span>
                  </li>
                  <li>
                    <div class="label">
                      <img class="icon" src="~assets/imgs/dashboard/icon_denglu.png" alt>
                      <span class="text">上次登录：</span>
                    </div>
                    <span>{{ companyInfo.lastLoginTime || '— —' }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- E 账户信息 -->
          </section>
          <div v-if="showRingChart" class="ring-content">
            <div class="content-wrap">
              <Title />
              <ve-ring
                style="background: #fff;"
                :colors="chartColors"
                height="300px"
                :data="chartData"
                :data-empty="noChartData"
                :loading="data.loading"
                :settings="chartSettings"
                :legend-visible="false"
                :judge-width="true"
              />
            </div>
          </div>
        </div>
      </div>

      <el-container class="right-wrap" :style="`width: ${100 - screenFit.slideWidth}%;`">
        <el-main>
          <div class="right-content" :style="`min-height:${minHeight}px`">
            <div class="banner" :style="`max-height:${screenFit.bannerMaxHeight}px;`">
              <img v-if="result.banner" :src="result.banner" alt="banner">
              <img v-else src="~assets/imgs/dashboard/banner.png" alt="banner">
            </div>
            <el-row :gutter="10" class="panel-list">
              <el-col :xs="24" :sm="8" class="panel-item">
                <div class="content-wrap" :style="`padding-top:${screenFit.panelPadding}px;padding-bottom:${screenFit.panelPadding}px;`">
                  <div class="item-content clearfix">
                    <img class="icon" src="~assets/imgs/dashboard/icon_yingyong.png" alt="我的应用">
                    <div class="text">
                      <CountTo
                        class="count"
                        :start-val="0"
                        :end-val="result.appAmount || 0"
                        :duration="1000"
                      />
                      <p>我的应用</p>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" class="panel-item">
                <div class="content-wrap" :style="`padding-top:${screenFit.panelPadding}px;padding-bottom:${screenFit.panelPadding}px;`">
                  <div class="item-content clearfix">
                    <img class="icon" src="~assets/imgs/dashboard/icon_daichuli.png" alt="待处理">
                    <div class="text">
                      <CountTo
                        class="count"
                        :start-val="0"
                        :end-val="result.waitForProcess || 0"
                        :duration="1000"
                      />
                      <p>待处理</p>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" class="panel-item">
                <div class="content-wrap" :style="`padding-top:${screenFit.panelPadding}px;padding-bottom:${screenFit.panelPadding}px;`">
                  <div class="item-content clearfix">
                    <img class="icon" src="~assets/imgs/dashboard/icon_quzheng.png" alt="取证数量">
                    <div class="text">
                      <CountTo
                        class="count"
                        :start-val="0"
                        :end-val="result.totalForensicAmount || 0"
                        :duration="1000"
                      />
                      <p>取证数量</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- / 面板数据 -->
            <div class="products">
              <Title title="水印列表" />
              <el-table
                :data="result.forensicProductCountVoList"
                header-align="center"
                class="table-content"
              >
                <el-table-column
                  prop="productName"
                  align="center"
                  show-overflow-tooltip
                  label="水印类型"
                >
                  <template slot-scope="scope">
                    <span
                      class="mark"
                      @click="handleSelectProduct(scope.row)"
                    >{{ scope.row.productName || '— —' }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="appAmount" align="center" show-overflow-tooltip label="应用数量">
                  <template slot-scope="scope">
                    <span>{{ scope.row.appAmount || 0 }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="forensicRecordAmount"
                  align="center"
                  show-overflow-tooltip
                  label="取证数量"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.forensicRecordAmount }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="createTime"
                  show-overflow-tooltip
                  align="center"
                  label="添加时间"
                />
              </el-table>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!-- E 主体内容 -->
  </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getSession, setSession } from '@/utils/tools';
import Title from './title';
import VeRing from 'v-charts/lib/ring.common';
import CountTo from 'vue-count-to';

const forensicResultMap = {
  0: '待取证',
  1: '自助取证失败',
  2: '深度取证待受理',
  3: '深度取证进行中',
  4: '取证成功',
  5: '深度取证失败',
  6: '已撤销'
};

export default {
  name: 'Dashboard',
  components: {
    Title,
    VeRing,
    CountTo
  },
  data() {
    this.chartSettings = {
      radius: [60, 95],
      offsetY: 170,
      labelLine: {
        show: true
      }
    };
    // 环形图配置文件
    return {
      chartData: {},
      chartColors: ['#23cae2', '#ea9294', '#f4b98a', '#94d2c5', '#bea3dc'],
      result: '',
      noChartData: false,
      minHeight: 0, // 侧边栏高度
      surplusDays: 0, // 剩余天数
      companyInfo: {},
      screenFit: {
        clientWidth: 0,
        clientHeight: 0,
        slideWidth: 22,
        bannerMaxHeight: 410,
        logoPadding: 50,
        panelPadding: 25
      }
    };
  },
  computed: {
    ...mapState({
      data: state => state.dashboard.data,
      clientWidth: state => state.global.client.width,
      clientHeight: state => state.global.client.height,
      userinfo: state => state.user.info
    }),
    showRingChart() {
      if (this.accountType == 3) return false;
      if (this.accountType == 4 && !this.isMainAccount) return false;
      return true;
    }
  },
  watch: {
    clientWidth(value) {
      if (value < 1530) {
        this.screenFit.slideWidth = 25;
        this.screenFit.logoPadding = 30;
        this.screenFit.bannerMaxHeight = 320;
        this.screenFit.panelPadding = 20;
      } else {
        this.screenFit.slideWidth = 22;
        this.screenFit.logoPadding = 50;
        this.screenFit.bannerMaxHeight = 410;
        this.screenFit.panelPadding = 25;
      }
    }
  },
  created() {
    const { orgId, userId } = getSession('T3_userinfo', {});
    const params = {
      orgId,
      userId: !this.isMainAccount ? userId : ''
    };
    this.getData(params).then(res => {
      const data = res.data;
      this.$store.commit('product/setData', data.data.forensicProductCountVoList)
      if (data.status === 0) {
        this.result = data.data;
        const showSurplusDaysTip = getSession('showSurplusDaysTip', 1);
        const expDays = data.data.expDays;
        if (
          this.accountType == 3 &&
          expDays <= 10 &&
          showSurplusDaysTip == 1
        ) {
          this.handleAlert(expDays);
        }
        if (
          this.accountType == 4 &&
          !this.isMainAccount &&
          expDays <= 10 &&
          showSurplusDaysTip == 1
        ) {
          this.handleAlert(expDays);
        }
        this.handleChartData(this.result.forensicResultCountVoList);
        this.handleUserData(this.result);
      }
    });
  },
  mounted() {
    this.minHeight = this.clientHeight - 124
  },
  methods: {
    ...mapActions({
      getData: 'dashboard/getData'
    }),
    // 选择产品
    handleSelectProduct(row) {
      this.$store.commit('product/setProduct', row);
      this.linkTo('/selfForensic/list');
    },
    // 处理charts数据
    handleChartData(data) {
      const chartData = { columns: ['名称', '次数'], rows: [] };
      const fail_item = { 名称: '取证待处理', 次数: 0 };
      let hasFailItem = false;
      if (data.length == 0) {
        this.noChartData = true;
        this.chartColors = ['#ccc'];
      }
      data.forEach((item, index) => {
        const key = item.forensicResult; let _item = {};
        if (key == 1 || key == 5 || key == 6) {
          fail_item['次数'] = fail_item['次数'] * 1 + item.forensicResultCount * 1;
          hasFailItem = true;
        } else {
          _item = {
            名称: forensicResultMap[key],
            次数: item.forensicResultCount
          };
          chartData.rows.unshift(_item);
        }
      });
      if (hasFailItem) {
        chartData.rows.push(fail_item);
      }
      this.chartData = chartData;
    },
    // 处理用户数据
    handleUserData(data) {
      this.companyInfo = {
        companyName: getSession('T3_userinfo').orgName,
        lastLoginTime: getSession('T3_userinfo').lastLoginTime,
        accountType: this.isMainAccount,
        logo: data.logo,
        orgDepthForensicAmount: data.orgDepthForensicAmount,
        orgDepthForensicNumber: data.orgDepthForensicNumber,
        userDepthForensicAmount: data.userDepthForensicAmount,
        userDepthForensicNumber: data.userDepthForensicNumber,
        expDays: data.expDays
      };
    },
    // 试用剩余天数提醒
    handleAlert(days) {
      let type = ''
      if (this.accountType == 3) type = '试用'
      if (this.accountType == 4) type = '体验'
      this.$alert(`您当前使用的为${type}版，${type}天数还剩${days}天。`, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        beforeClose: (action, instance, done) => {
          setSession('showSurplusDaysTip', 2);
          done();
        }
      });
    }
  }
};
</script>

<style lang='scss'>
@import '../../assets/scss/variable.scss';

#Dashboard {
  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .side-wrap {
      width: 22%;
      min-width: 320px;
      .side-content {
        position: relative;
        background: #fff;
        height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        .role {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 2;
          width: 70px;
          img {
            width: 100%;
          }
        }
        .ring-content {
          .content-wrap {
            padding-top: 30px;
            border-top: solid 1px #ededed;
          }
        }
      }
    }
    .right-wrap {
      width: 78%;
      min-width: 890px;
      .el-main {
        padding: 0;
        border-left: solid 20px $bgColor;
      }

      .right-content {
        background: #fff;
        overflow: hidden;
        .banner {
          width: 100%;
          max-height: 410px;
          min-height: 320px;
          overflow: hidden;
          img {
            width: 100%;
            object-fit: cover;
            max-height: 410px;
          }
        }
        .panel-list {
          border-bottom: solid 10px #efefef;
          background: #efefef;
          .panel-item {
            min-width: 170px;
            .content-wrap {
              border-top: solid 10px #efefef;
              background: #fff;
              background: #fff;
              text-align: center;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
              border-radius: 2px;
              .item-content {
                display: inline-block;
                .icon {
                  float: left;
                  width: 45px;
                  margin-top: 25px;
                }
                .text {
                  padding-left: 60px;
                  text-align: center;
                  .count {
                    font-size: 44px;
                  }
                }
                p {
                  font-weight: bold;
                  font-size: 16px;
                }
              }
            }
          }
        }
        .products {
          padding: 20px 20px 20px 0;
          box-sizing: border-box;
          min-height: 220px !important;
          .table-content {
            padding: 20px 0 0 20px;
            thead th {
              padding: 12px 0;
            }
            .mark {
              color: $primaryColor;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
          }
          .el-table::before {
            left: 20px;
          }
        }
      }
    }
  }
  #Company {
    .company-header {
      padding: 0 10px;
      .content {
        padding-top: 40px;
        padding-bottom: 40px;
        border-bottom: solid 1px #ededed;
        .logo {
          text-align: center;
          img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            object-fit: contain;
          }
        }
        h6 {
          margin-top: 10px;
          text-align: center;
          font-size: 18px;
          color: #333;
          letter-spacing: 1px;
        }
        p {
          text-align: center;
          font-size: 14px;
          line-height: 26px;
          letter-spacing: 1px;
          color: #666666;
        }
      }
    }
    .company-footer {
      padding: 0 10px;
      .content {
        padding: 35px 0;
        ul {
          padding: 0 10px;
          li {
            display: flex;
            align-items: center;
            padding: 5px 0;
            font-size: 14px;
            .label {
              width: auto;
              font-size: 14px;
              .icon {
                float: left;
                width: 12px;
                margin-top: 4px;
              }
              span {
                padding-left: 5px;
              }
            }
          }
          li:last-child .icon {
            margin-top: 4px;
          }
        }
      }
    }
  }
}
</style>
